import React from 'react';
import classNames from 'classnames/bind';
import { Link, useParams } from 'react-router-dom';

import { organizationPlansPath } from 'application/types/routes';
import { ApplicationParams } from 'types/route_params';

import { useCurrentOrganization } from 'hooks/api/useCurrentOrganization';

import styles from './PricingPlanLabel.module.scss';

const c = classNames.bind(styles);

export type PricingPlanLabelLinkProps = React.PropsWithChildren<{
  className?: string;
  hasLink?: boolean;
}>;

export function PricingPlanLabelLink({
  className,
  hasLink,
  children,
}: PricingPlanLabelLinkProps) {
  const { data: organization } = useCurrentOrganization();
  const { applicationID } = useParams<ApplicationParams>();

  if (hasLink) {
    return (
      <Link
        className={c(className, 'wrap')}
        to={organizationPlansPath(applicationID, organization?.id)}
      >
        {children}
      </Link>
    );
  }

  return <div className={className}>{children}</div>;
}
